'use client';

import { type Route } from 'next';
import { usePathname } from 'next/navigation';
export function ActivePath(t0) {
  const {
    path,
    exact: t1,
    active,
    inactive
  } = t0;
  const exact = t1 === undefined ? false : t1;
  const pathname = usePathname();
  const regex = exact ? new RegExp(`^${path}\/?$`) : new RegExp(`^${path}(\/.*)?$`);
  if (pathname.startsWith(path) && regex.test(pathname)) {
    return active;
  }
  return inactive;
}